import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

export const MORTGAGE_APPLICATIONS_LIST = "MORTGAGE_APPLICATIONS_LIST";
export const MORTGAGE_APPLICATION_VIEW_LOG = "MORTGAGE_APPLICATION_VIEW_LOG";
export const MORTGAGE_APPLICATION_SHARE = "MORTGAGE_APPLICATION_SHARE";
export const CLEAR_MORTGAGE_APPLICATION_ERRORS = "clearMortgageApplicationErrors";

export const SET_MORTGAGE_APPLICATION_ERROR = "setMortgageApplicationError";
export const REMOVE_MORTGAGE_APPLICATION_ERRORS = "removeMortgageApplicationErrors";

const state = {
    errors: null,
};

const actions = {
    [MORTGAGE_APPLICATIONS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/mortgageapplications?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: "error", msg: data._metadata.message});
                        context.commit(SET_MORTGAGE_APPLICATION_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_MORTGAGE_APPLICATION_ERROR, response.errors);
                });
        });
    },
    [MORTGAGE_APPLICATION_VIEW_LOG](context, payload) {
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.post("api/logmortgageapplicationview", {id: payload.id})
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [MORTGAGE_APPLICATION_SHARE](context, payload) {
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.post("api/sharemortgageapplication", payload)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        this.dispatch(SET_SNACK, {clr: "success", msg: data._metadata.message});
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: "error", msg: data._metadata.message});
                        reject(data);
                    }
                })
                .catch((err) => {
                    this.dispatch(SET_SNACK, {clr: "error", msg: "Failed to share application"});
                    reject(err);
                });
        });
    },
    [CLEAR_MORTGAGE_APPLICATION_ERRORS](context) {
        context.commit(REMOVE_MORTGAGE_APPLICATION_ERRORS);
    }
};

const mutations = {
    [SET_MORTGAGE_APPLICATION_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_MORTGAGE_APPLICATION_ERRORS](state) {
        state.errors = null;
    }
};

export default {
    state,
    actions,
    mutations
};
